/**PT Impact*/
export const impact = {
  impactMetrics: {
    pageTitle: "Impacto e Métricas",
    pageSubtitle: "Medindo Liderança Jovem, Saúde Mental e Oportunidade Econômica em 114 países JCI"
  },
  fiiFormula: {
    stats: {
      mentalDisorders: "1 em 7 afetados por transtornos mentais",
      mentalHealthLimiting: "68% citam saúde mental como limitante",
      emergingAccess: "Mercados emergentes (10-30% acesso)",
      digitalSkillsGap: "92% dos empregos precisam de habilidades digitais (apenas 30% treinados)",
      youthVsAdult: "13% jovens globais (vs 4,9% adultos)",
      neetCrisis: "256M jovens (20,4%) não estão na educação/trabalho",
      ssaAspiration: "52% dos jovens da África Subsaariana querem iniciar negócios",
      fundingGap: "Apenas 3% recebem financiamento (lacuna de $1,7T globalmente)",
      womenGap: "Mulheres empreendedoras 35% sub-representadas"
    },
    reasoning: {
      mentalHealth: "Peso pesado reflete importância fundamental - saúde mental permite todas as outras capacidades",
      workforce: "Peso significativo reflete emprego como porta de entrada para independência econômica",
      entrepreneurship: "Peso significativo reflete potencial de inovação e necessidade de autoemprego"
    },
    mentalHealthStat1: "1 em 7 afetados por transtornos mentais",
    mentalHealthStat2: "68% citam saúde mental como limitante",
    mentalHealthStat3: "Mercados emergentes (10-30% acesso)",
    workforceStat1: "92% dos empregos precisam de habilidades digitais (apenas 30% treinados)",
    workforceStat2: "13% desemprego juvenil global (vs 4,9% adultos)",
    workforceStat3: "256M jovens (20,4%) não estão na educação/trabalho",
    entrepreneurshipStat1: "52% dos jovens da África Subsaariana querem iniciar negócios",
    entrepreneurshipStat2: "Apenas 3% recebem financiamento (lacuna de $1,7T globalmente)",
    entrepreneurshipStat3: "Mulheres empreendedoras 35% sub-representadas",
    mentalHealthReasoning: "Peso pesado reflete importância fundamental - saúde mental permite todas as outras capacidades",
    workforceReasoning: "Peso significativo reflete emprego como porta de entrada para independência econômica",
    entrepreneurshipReasoning: "Peso significativo reflete potencial de inovação e necessidade de autoemprego"
  },
  engagement: {
    title: "Métricas de Engajamento",
    subtitle: "Análise de participação e atividade de membros",
    eventParticipation: "Participação em Eventos",
    volunteerHours: "Horas de Voluntariado",
    projectContributions: "Contribuições de Projeto",
    monthlyActiveUsers: "Usuários Ativos Mensais"
  },
  network: {
    title: "Análise de Rede",
    subtitle: "Conexões globais e padrões de colaboração",
    totalConnections: "Conexões Totais",
    activeProjects: "Projetos Ativos",
    strategicPartnerships: "Parcerias Estratégicas",
    knowledgeTransfer: "Transferência de Conhecimento",
    collectiveImpact: "Impacto Coletivo",
    progress: "Progresso",
    target: "Meta"
  },
  trends: {
    title: "Análise de Tendências e Previsões",
    subtitle: "Evolução histórica da JCI e projeções baseadas em IA para 2026-2030",
    historical: "Evolução Histórica (2015-2025)",
    predictions: "Projeções 2026-2030",
    confidence: "confiança",
    keyTrends: "Tendências Chave Identificadas",
    sustainedGrowth: "Crescimento Sustentado",
    digitalRevolution: "Revolução Digital",
    wellbeingFocus: "Foco em Bem-estar",
    sustainability: "Sustentabilidade",
    seasonalPatterns: "Padrões Sazonais",
    enrollments: "Inscrições",
    projects: "Projetos",
    events: "Eventos",
    members: "Membros",
    countries: "Países",
    imh: "IMH"
  },
  status: {
    strong: "Forte",
    growing: "Crescendo",
    expanding: "Expandindo",
    stable: "Estável",
    emerging: "Emergente",
    active: "Ativo",
    expansion: "Expansão",
    pilot: "Piloto",
    beta: "Beta"
  },
  advancedMetrics: {
    title: "Métricas Avançadas",
    subtitle: "Análise detalhada de desempenho, conversão e indicadores-chave para Visão 2040",
    conversionFunnel: "Funil de Conversão",
    websiteVisitors: "Visitantes do Site",
    interested: "Interessados",
    candidates: "Candidatos",
    interviewed: "Entrevistados",
    activeMembers: "Membros Ativos",
    totalConversionRate: "Taxa de Conversão Total",
    costPerAcquisition: "Custo por Aquisição",
    programROI: "ROI do Programa",
    performanceTrends: "Tendências de Desempenho",
    members: "Membros",
    countries: "Países",
    programs: "Programas",
    keyPerformanceIndicators: "Indicadores-Chave de Desempenho",
    retentionRate: "Taxa de Retenção",
    membersActive12Months: "Membros ativos por 12+ meses",
    digitalEngagement: "Engajamento Digital",
    onlineEventParticipation: "Participação em eventos online",
    memberSatisfaction: "Satisfação do Membro",
    avgProgramEvaluation: "Avaliação média do programa",
    averageLeadershipTime: "Tempo Médio de Liderança",
    joiningToFirstLeadership: "Da adesão à primeira posição de liderança",
    target: "Meta",
    progress: "Progresso"
  },
  performanceKPIs: {
    title: "KPIs de Desempenho",
    subtitle: "Indicadores-chave de desempenho e metas para 2025",
    updatedAgo: "Atualizado",
    memberRetentionRate: "Taxa de Retenção de Membros",
    annualRetentionVsTarget: "Retenção anual de membros vs meta",
    programROI: "ROI do Programa",
    trainingProgramsROI: "Retorno sobre investimento para programas de treinamento",
    newMarkets: "Novos Mercados",
    newCountriesEntered: "Novos países entrados este ano",
    communityImpactScore: "Pontuação de Impacto Comunitário",
    aggregateCommunityImpact: "Medição agregada de impacto comunitário",
    memberEngagement: "Engajamento de Membros",
    activeParticipationJCI: "Participação ativa em atividades JCI",
    leadershipPipeline: "Pipeline de Liderança",
    membersInLeadershipTrack: "Membros no curso de desenvolvimento de liderança",
    performance: "desempenho",
    growth: "crescimento",
    impact: "impacto",
    engagement: "engajamento",
    target: "Meta"
  },
  aiInsights: {
    title: "Centro de Insights de IA",
    subtitle: "Análises preditivas, recomendações estratégicas e cenários 'what-if' para decisões inteligentes",
    aiChat: "Chat IA",
    recommendations: "Recomendações",
    insights: "Insights",
    whatIf: "What-If",
    jciAssistant: "Assistente Inteligente JCI",
    askAboutData: "Faça perguntas sobre dados, tendências e estratégias",
    askPlaceholder: "Pergunte sobre tendências, análises ou estratégias...",
    greeting: "Olá! Sou o assistente de insights JCI. Como posso ajudá-lo a analisar dados e descobrir oportunidades estratégicas?",
    analyzing: "Analisando sua pergunta sobre",
    growthPotential: "potencial de crescimento nos próximos 18 meses",
    priority: "Prioridade",
    confidence: "Confiança",
    viewDetails: "Ver Detalhes",
    expectedImpact: "Impacto Esperado",
    estimatedTime: "Tempo estimado",
    simulateScenario: "Simular Cenário",
    strategicExpansion: "Expansão Estratégica na América Latina",
    strategicExpansionDesc: "Dados indicam 40% de potencial de crescimento inexplorado em países como Colômbia e Peru.",
    digitalMentalHealth: "Programa de Saúde Mental Digital",
    digitalMentalHealthDesc: "Implementar plataforma digital aumentaria engajamento em 60% em comunidades jovens.",
    techPartnerships: "Parcerias Tecnológicas",
    techPartnershipsDesc: "Integração com startups locais poderia acelerar programas de inovação em 45%.",
    growth: "Crescimento",
    wellbeing: "Bem-estar",
    innovation: "Inovação",
    millennialEngagement: "Engajamento Millennial",
    millennialEngagementDesc: "Crescimento acelerado na participação de 25-30 anos",
    sustainableProjects: "Projetos Sustentáveis",
    sustainableProjectsDesc: "Iniciativas ESG mostraram ROI superior",
    regionalRetention: "Retenção Regional",
    regionalRetentionDesc: "Algumas regiões precisam de atenção especial",
    whatIfLeadership: "E se aumentarmos o investimento em programas de liderança em 25%?",
    whatIfLeadershipImpact: "35% aumento na qualidade de liderança, 2,3x mais participação em eventos",
    whatIfAI: "E se implementarmos IA em todos os processos administrativos?",
    whatIfAIImpact: "40% redução no tempo administrativo, $2,1M economia anual",
    budget: "Orçamento",
    months: "meses",
    focusYoungLeaders: "Foco em jovens líderes",
    totalAutomation: "Automação total",
    training: "Treinamento",
    gradualMigration: "Migração gradual"
  },
  homeGlobalPresence: {
    title: "Presença Global JCI",
    subtitle: "Ativa em 114 países em 4 regiões",
    regions: "Regiões",
    countries: "Países",
    members: "Membros",
    localOrgs: "Orgs Locais"
  },
  fii: {
    title: "Índice de Futuros da Juventude (YFI)",
    measuringYouthOpportunity: "Medindo Oportunidades da Juventude em 114 Países",
    scale: "Escala: 0-100 (Maior = Melhor Oportunidade Juvenil)",
    mentalHealth: "Saúde Mental",
    workforceEducation: "Força de Trabalho e Educação",
    entrepreneurshipSupport: "Apoio ao Empreendedorismo",
    mentalHealthQuote: "A saúde mental é a base sobre a qual todas as outras capacidades são construídas.",
    workforceQuote: "O emprego é a porta de entrada para a independência econômica.",
    entrepreneurshipQuote: "Inovação e autoemprego são caminhos essenciais para a oportunidade juvenil.",
    globalCrisis: "Crise Global",
    employmentBarrier: "Barreira ao Emprego",
    mostVulnerable: "Mais Vulneráveis",
    skillGap: "Lacuna de Habilidades",
    unemployment: "Desemprego Juvenil",
    neetCrisis: "Crise NEET",
    aspiration: "Aspiração Empreendedora",
    fundingGap: "Lacuna de Financiamento",
    genderGap: "Lacuna de Gênero",
    whyThisWeighting: "Por Que Esta Ponderação?",
    ofTotalScore: "do score total",
    weight: "Peso",
    source: "Fonte",
    indicators: "Indicadores",
    countriesMeasured: "Países Medidos",
    jciNationalOrgs: "Orgs Nacionais JCI",
    completeData: "Dados Completos",
    countries: "países",
    averageFII: "YFI Médio",
    highest: "Mais Alto",
    lowest: "Mais Baixo",
    pointRange: "Faixa de Pontos",
    countriesRanked: "Países Classificados",
    excellent: "Excelente",
    good: "Bom",
    moderate: "Moderado",
    deficient: "Deficiente",
    challenges: "Desafios",
    critical: "Crítico",
    globalRankings: "Índice Global YFI",
    searchCountry: "Buscar país...",
    allRegions: "Todas as Regiões",
    rank: "Posição",
    country: "País",
    region: "Região",
    score: "Pontuação",
    classification: "Classificação",
    
    // Component Breakdown & Benchmarks
    componentBreakdown: "Detalhamento por Componente",
    vsBenchmarks: "vs Referências",
    vsGlobalAvg: "vs Média Global",
    globalAverage: "Média Global",
    data: "Dados",
    complete: "Completo",
    limited: "Limitado",
    
    // Legend labels
    legendGood: "Bom",
    legendModerate: "Moderado",
    legendChallenges: "Desafios",
    legendCritical: "Crítico",
    
    useFIIData: "Usar Dados YFI",
    useFIIDataDesc: "Baixe dados do índice e documentação metodológica para pesquisa e advocacia",
    exportRankings: "Exportar Índice (CSV)",
    downloadMethodology: "Baixar Metodologia (PDF)",
    comingSoon: "Em Breve",
    methodologyComingSoon: "PDF da metodologia em breve",
    researchCitations: "Citações de Pesquisa",
    sourceWhoDescription: "Acesso a serviços de saúde mental, lacunas de tratamento, cobertura de políticas",
    sourceIloDescription: "Desemprego juvenil, taxas de NEET, qualidade da força de trabalho",
    sourceGemDescription: "Empreendedorismo em estágio inicial, ambiente de negócios",
    sourceWorldBankDescription: "Dados de apoio para a dimensão de empreendedorismo",
    aboutMethodology: "Sobre a Metodologia",
    aboutMethodologyDesc: "O YFI usa dados verificados da OMS, OIT, Banco Mundial e outras fontes confiáveis.",
    howToCite: "Como Citar",
    citationText: "JCI Development Councils Youth Futures Observatory (2025). Índice de Futuros da Juventude.",
    insightsTitle: "Insights Estratégicos",
    insightsSubtitle: "Principais descobertas da análise YFI",
    finding: "Descoberta",
    dataEvidence: "Evidência de Dados",
    implication: "Implicação",
    actionForJCI: "Ação para JCI",
    insight1Title: "Saúde Mental como Base",
    insight2Title: "Descompasso Habilidades-Emprego",
    insight3Title: "Disparidades Regionais",
    insight4Title: "Paradoxo do Empreendedorismo",
    insight5Title: "Lacunas de Gênero Persistem",
    dataVintage: "Período dos Dados",
    dataVintageDesc: "Dados 2023-2024 de fontes internacionais verificadas",
    methodologyTitle: "Metodologia YFI",
    methodologySubtitle: "Como calculamos o Índice de Futuros da Juventude",
    formulaExplanation: "Explicação da Fórmula",
    pillarWeights: "Pesos dos Pilares",
    dataSourcesTitle: "Fontes de Dados",
    calculationFormula: "Fórmula de Cálculo",
    threeDimensions: "As Três Dimensões",
    officialDataSources: "Fontes de Dados Oficiais",
    dataCoverage: "Cobertura de Dados",
    dataCoverageDesc: "O YFI cobre 114 países membros da JCI. A disponibilidade de dados varia por país e indicador.",
    openData: "Dados Abertos",
    openDataDesc: "Todos os dados de origem estão publicamente disponíveis de instituições autorizadas.",
    zeroSynthetic: "Zero Dados Sintéticos",
    zeroSyntheticDesc: "Usamos apenas dados reais e verificados - nunca valores gerados por IA ou estimados.",
    fullTransparency: "Transparência Total",
    fullTransparencyDesc: "Metodologia completa e cálculos estão documentados publicamente.",
    scientificRigor: "Rigor Científico",
    scientificRigorDesc: "Metodologia revisada e validada por parceiros de pesquisa.",
    regionalPerformance: "Desempenho Regional",
    topPerformers: "Melhores Desempenhos",
    bottomPerformers: "Piores Desempenhos",
    keyTakeaways: "Principais Conclusões"
  },
  globalFIIMap: {
    title: "Mapa Global YFI",
    subtitle: "Explore métricas de oportunidade juvenil em todos os países JCI",
    jciCountries: "Países JCI",
    totalMembers: "Membros Totais",
    completeData: "Dados Completos",
    globalRegions: "Regiões Globais",
    regionalOverview: "Visão Regional",
    countries: "Países",
    avgFII: "YFI Médio",
    leader: "Líder",
    searchCountry: "Buscar país...",
    allRegions: "Todas as Regiões",
    allClassifications: "Todas as Classificações",
    regionAsiaPacific: "Ásia e o Pacífico",
    regionEurope: "Europa",
    regionAmericas: "América",
    regionAfricaMe: "África e Oriente Médio",
    excellent: "Excelente",
    good: "Bom",
    moderate: "Moderado",
    deficient: "Deficiente",
    critical: "Crítico",
    countriesTotal: "Total de Países",
    matching: "correspondendo",
    fiiDataset: "Dataset YFI",
    withCompleteData: "com dados completos",
    limitedData: "Dados Limitados",
    members: "membros"
  },
  fiiInsights: {
    insight: "Insight",
    sourceAttribution: "Relatório de Impacto JCI 2025 | Análise Regional YFI 2024",
    priority: {
      critical: "Crítico",
      high: "Alto",
      medium: "Médio"
    },
    mentalHealth: {
      finding: "Saúde mental é o melhor preditor do score YFI geral. Países com altos scores de saúde mental consistentemente têm melhor classificação.",
      mhScoreVariation: "Variação do Score de SM",
      wfEtScoreVariation: "Variação dos Scores de FT & Emp",
      potentialImprovement: "Melhoria Potencial do YFI",
      implication: "Investir em saúde mental gera o maior retorno na oportunidade juvenil geral.",
      action: "Priorizar programas de saúde mental nas iniciativas JCI, especialmente em regiões de baixo score."
    },
    skillsMismatch: {
      finding: "Apesar da alta matrícula educacional, o desemprego juvenil permanece elevado devido ao descompasso de habilidades.",
      youthInEducation: "Jovens na Educação",
      youthUnemployment: "Taxa de Desemprego Juvenil",
      neetPopulation: "População NEET",
      digitalSkillsJobs: "Empregos que Precisam de Habilidades Digitais",
      implication: "A educação tradicional não está preparando os jovens para a força de trabalho moderna.",
      action: "Desenvolver programas de treinamento baseados em habilidades focados em competências digitais e empreendedoras."
    },
    regionalDisparities: {
      finding: "Lacunas significativas existem entre regiões, com África-Oriente Médio enfrentando os maiores desafios.",
      mentalHealthGap: "Lacuna de Saúde Mental (Europa vs África-OM)",
      workforceGap: "Lacuna de Força de Trabalho",
      entrepreneurshipGap: "Lacuna de Empreendedorismo",
      implication: "Uma abordagem única não funcionará; estratégias regionais são necessárias.",
      action: "Desenvolver programas específicos por região e aumentar alocação de recursos para áreas carentes."
    },
    entrepreneurship: {
      finding: "Alta aspiração empreendedora existe em regiões em desenvolvimento, mas acesso a capital é severamente limitado.",
      ssaRate: "Taxa de Empreendedorismo na ASS",
      financingGap: "Lacuna de Financiamento Global",
      africaMeShare: "Participação África-OM em Startups Globais",
      youthWanting: "Jovens Querendo Iniciar Negócio",
      implication: "Potencial empreendedor inexplorado existe, restringido pelo acesso a financiamento.",
      action: "Criar programas de microfinanciamento e conectar jovens empreendedores com investidores."
    },
    gender: {
      finding: "Mulheres enfrentam desvantagens compostas em todas as três dimensões do YFI.",
      depressionRates: "Taxas de Depressão de Mulheres",
      womenUnemployment: "Desemprego de Mulheres",
      neetWomen: "Participação de Mulheres no NEET",
      womenLedStartups: "Startups Lideradas por Mulheres",
      vcToWomen: "Financiamento VC para Mulheres",
      implication: "Barreiras específicas de gênero requerem intervenções direcionadas.",
      action: "Lançar programas de liderança e empreendedorismo focados em mulheres."
    }
  },
  fiiMethodology: {
    formulaExplanation: "O YFI é calculado como uma média ponderada de três dimensões: Saúde Mental (40%), Força de Trabalho & Educação (30%), e Apoio ao Empreendedorismo (30%).",
    mentalHealth: {
      description: "Mede o bem-estar mental juvenil, acesso a serviços de saúde mental e bem-estar psicológico geral."
    },
    workforce: {
      description: "Avalia taxas de emprego juvenil, qualidade da educação, desenvolvimento de habilidades e acesso ao mercado de trabalho."
    },
    entrepreneurship: {
      description: "Avalia ambiente de negócios, acesso a financiamento, infraestrutura digital e ecossistema de startups."
    },
    indicators: {
      mentalDisorderPrevalence: "Prevalência de Transtornos Mentais",
      youthSuicideRate: "Taxa de Suicídio Juvenil",
      mentalHealthServiceAccess: "Acesso a Serviços de Saúde Mental",
      mentalWellbeingIndex: "Índice de Bem-estar Mental",
      youthUnemploymentRate: "Taxa de Desemprego Juvenil",
      neetRate: "Taxa NEET",
      tertiaryEducation: "Matrícula no Ensino Superior",
      humanCapitalIndex: "Índice de Capital Humano",
      easeOfDoingBusiness: "Facilidade de Fazer Negócios",
      totalEntrepreneurialActivity: "Atividade Empreendedora Total",
      accessToFinancing: "Acesso a Financiamento",
      digitalInfrastructure: "Infraestrutura Digital"
    },
    dataTypes: {
      education: "Educação",
      multiDimensional: "Multidimensional",
      wellbeing: "Bem-estar",
      digitalInfrastructure: "Infraestrutura Digital"
    },
    access: {
      publicApiDownloads: "API Pública & Downloads",
      ilostatPublicApi: "API Pública ILOSTAT",
      publicDataPortal: "Portal de Dados Públicos",
      freeApiAccess: "Acesso Gratuito à API",
      publicReports: "Relatórios Públicos",
      publicData: "Dados Públicos",
      annualPublicRelease: "Lançamento Público Anual",
      publicStatistics: "Estatísticas Públicas"
    }
  }
} as const;
